import service from '@/utils/request';
export var getWhiteListIPs = function getWhiteListIPs() {
  return service({
    url: '/trustDecision/getWhiteListIPs',
    method: 'get'
  });
};
export var modifyWhiteListIP = function modifyWhiteListIP(data) {
  return service({
    url: '/trustDecision/modifyWhiteListIP',
    method: 'post',
    data: data
  });
};